import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useOutletContext } from "react-router-dom";

import ModalAppsEmpty from "@/shared/ui/ModalAppsEmpty/ModalAppsEmpty";
import ModalSaveModeGroups from "@/shared/ui/ModalSaveModeGroups/ModalSaveModeGroups";
import styles from "@/widgets/modalSaveMode/ui/ModalSaveMode/ModalSaveMode.module.scss";
import { useCurrentOrganization } from "@/Hooks";

const SavedModeGroupListView = () => {
  const currenOrganization = useCurrentOrganization();
  const location = useLocation();

  // Get context from parent component
  const {
    selectedGroups,
    setSelectedGroups,
    savedGroups,
    handleFetchSavedGroups,
  } = useOutletContext();

  const imageDimensions = [
    { width: 246.88, height: 534 },
    { width: 226, height: 490.59 },
    { width: 206, height: 447.17 },
    { width: 186, height: 403.76 },
  ];

  const [selectedPhotos, setSelectedPhotos] = useState<
    Set<{ id: number; url: string; videoId: number; type: string }>
  >(new Set());
  const lastGroupRef = useRef<HTMLDivElement>(null);
  const [groupIdPoint, setGroupIdPoint] = useState<null | number>(null);
  const [filterValueGroup, setFilterValueGroup] = useState("");
  const [isCurrentGroupActive, setIsCurrentGroupActive] = useState(false);
  const [modalAddGroupActive, setModalAddGroupActive] = useState(false);
  const photoGroups = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [groupActive, setGroupActive] = useState(true);

  const handleGroupSelect = (id: number) => {
    setSelectedGroups((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(id)) {
        newSelected.delete(id);
      } else {
        newSelected.add(id);
      }
      return newSelected;
    });
  };

  const handleOpenGroup = () => {
    setIsCurrentGroupActive(true);
  };

  useEffect(() => {
    handleFetchSavedGroups();
  }, [currenOrganization]);

  useEffect(() => {
    if (location.state && location.state.openAddGroupModal) {
      setModalAddGroupActive(true);
      if (location.state.selectedPhotos) {
        setSelectedPhotos(new Set(location.state.selectedPhotos));
      }

      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div ref={containerRef} className={styles.root}>
      <div className={styles.mainContent}>
        {groupActive ? (
          <div className={styles.groupPhotoContainerWrapper}>
            {isCurrentGroupActive ? (
              <div
                ref={photoGroups}
                className={styles.groupPhotoContainerActive}
              ></div>
            ) : (
              <div className={styles.groupPhotoContainer}>
                {savedGroups.length > 0 ? (
                  savedGroups.map((item, index) => {
                    const countScreens =
                      item.total_saved_points +
                      item.total_saved_store_screens +
                      item.total_saved_animations +
                      item.total_saved_ob_screens;
                    const isLastGroup = index === savedGroups.length - 1;
                    return (
                      <ModalSaveModeGroups
                        key={index}
                        selectGroupActive={true}
                        selectedGroups={selectedGroups}
                        item={item}
                        isLastGroup={isLastGroup}
                        handleGroupSelect={handleGroupSelect}
                        handleOpenGroup={handleOpenGroup}
                        setFilterValueGroup={setFilterValueGroup}
                        setGroupIdPoint={setGroupIdPoint}
                        countScreens={countScreens}
                        imageDimensions={imageDimensions}
                        ref={lastGroupRef}
                      />
                    );
                  })
                ) : (
                  <ModalAppsEmpty
                    text="no groups added"
                    img="/img/groupEmptyIcon.svg"
                  />
                )}
              </div>
            )}
          </div>
        ) : (
          <div ref={photoGroups} className={styles.photosContainer}></div>
        )}
      </div>
    </div>
  );
};

export { SavedModeGroupListView };
